export default "<button class=\"bg-beige-200\" (click)=\"toggled.emit($event)\">\n    <ng-content></ng-content>\n</button>\n\n";